<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white my-3">
              Aqui você pode conferir todos os relatórios criados e vinculadas à
              aos colaboradores. Todo novo relatório criado aparecerá
              automaticamente na tabela abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-12">
          <div
            class="card shadow table-container vld-parent"
            ref="colaboradores_table"
          >
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">
                    Lista de <span class="text-orange">relatórios</span>
                  </h3>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <base-table
                class="table align-items-center table-flush"
                thead-classes="thead-light"
                tbody-classes="list"
                :data="tableData"
                type="hover"
              >
                <template slot="columns">
                  <th>#</th>
                  <th>Colaborador</th>
                  <th>Data de criação</th>
                  <th>Ações</th>
                </template>
                <template slot-scope="{ row, index }">
                  <td class="py-4">{{ index + 1 }}</td>
                  <th scope="row">
                    {{ row.collaborator_name }}
                  </th>
                  <td>
                    <div class="mt-1">
                      {{ formatDate(row.created_at) }}
                    </div>
                  </td>
                  <td>
                    <div
                      @click="viewReport(row.url)"
                      class="btn btn-white py-1 px-2 cursor-pointer"
                    >
                      <i class="fas fa-download text-info"></i>
                    </div>
                    <div
                      @click="deleteReport(row.id)"
                      class="btn btn-white py-1 px-2 cursor-pointer"
                    >
                      <i class="fas fa-trash text-danger"></i>
                    </div>
                  </td>
                </template>
              </base-table>
              <p v-if="empty" class="text-center text-warning mt-3">
                Não há relatórios cadastrados
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!empty" class="row">
        <div class="col-12 text-right">
          <hr class="mt-3 mb-1" />
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalConfirmation"
      modal-classes="modal-default modal-dialog-centered"
      body-classes="pb-2"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_remove">
        <div class="text-center">
          <i class="fas fa-trash fa-3x"></i>
          <h4 class="heading mt-4">Confirmar exclusão</h4>
          <p class="mt-3">
            Você realmente deseja excluir o relatório?
            <br />
            <strong>ESSA AÇÃO NÃO PODERÁ SER REVERTIDA</strong>
          </p>
        </div>
        <base-alert
          type="danger"
          class="text-center mb-2"
          v-if="modals.modalConfirmation.error"
          >Ocorreu um erro ao remover a pergunta. Por favor, tente
          novamente.</base-alert
        >
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.modalConfirmation = false"
        >
          Voltar
        </base-button>
        <base-button type="white text-danger" @click="confirmDelete()">
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "colaboradores_table",
  data() {
    return {
      tableData: [],
      empty: false,
      modals: {
        modalConfirmation: false,
        reportId: null,
        error: false
      }
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.colaboradores_table,
      width: 90,
      height: 90
    });
    try {
      const { data } = await api.get("/company/collaborators/export");
      if (data.data.length) this.tableData = data.data;
      else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar os colaboradores");
    }
  },
  methods: {
    async deleteReport(id) {
      console.log(id);
      this.modals.modalConfirmation = true;
      this.modals.reportId = id;
    },
    async viewReport(url) {
      window.open(url, "_blank");
    },
    async confirmDelete() {
      const loader = this.$loading.show({
        container: this.$refs.colaboradores_table,
        width: 90,
        height: 90
      });
      try {
        await api.delete(
          `/company/collaborators/export/${this.modals.reportId}`
        );
        this.tableData = this.tableData.filter(
          item => item.id !== this.modals.reportId
        );
        if (!this.tableData.length) this.empty = true;
        this.modals.modalConfirmation = false;
      } catch (error) {
        console.log(error);
        this.$toasted.error("Ocorreu um erro ao gerar o PDF");
      }
      loader.hide();
    }
  }
};
</script>
<style scoped>
.table-container {
  min-height: 150px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
